import { useBrandSpecialQualifyingStatus } from '@iheartjane/data-access/react-query';
import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { SpecialCallout } from '@iheartjane/menu';

import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

import { BrandSpecialCallout } from '../../brandSpecialCallout/brandSpecialCallout';
import type { CartBrandSpecialCalloutProps } from '../janeGoldCallout.types';

export const CartBrandSpecialCallout = ({
  brandSpecial,
  cartBrandDiscounts,
  cartUuid,
  isAuthenticated,
  onBrandSpecialClick,
  storeId,
}: CartBrandSpecialCalloutProps) => {
  const specialsRedesignMenu = useFlag(FLAGS.c3SpecialsRedesignMenu);
  const cartBrandDiscountIds = cartBrandDiscounts?.map(
    ({ brand_special_id }) => brand_special_id
  );

  const { data: status } = useBrandSpecialQualifyingStatus(
    {
      cartUuid: cartUuid,
      specialId: brandSpecial?.id,
      storeId: storeId,
    },
    { enabled: brandSpecial?.special_type !== 'product' }
  );

  // if the bundle has technically been unlocked but has not been applied in the cart
  // it means a better special has been applied and we should not render the callout
  if (
    !cartBrandDiscountIds?.includes(brandSpecial.id) &&
    status?.qualifying_status === 'applied'
  ) {
    return null;
  }

  return (
    <li aria-label={`You are eligible for this reward: ${brandSpecial.title}`}>
      {specialsRedesignMenu ? (
        <SpecialCallout
          key={brandSpecial.id}
          brandImage={brandSpecial.product_brand.logo_url || ''}
          brandName={brandSpecial.product_brand.name}
          isApplied={false}
          isAuthenticated={isAuthenticated}
          isGold
          isQualified={false}
          onClick={() =>
            onBrandSpecialClick && onBrandSpecialClick(brandSpecial)
          }
          segmented={brandSpecialOrProductHasSegments({
            brandSpecial: brandSpecial,
          })}
          specialTitle={brandSpecial.title}
          specialType={
            brandSpecial.special_type === 'product' ? 'product' : 'bundle'
          }
          variant="bag"
        />
      ) : (
        <BrandSpecialCallout
          key={brandSpecial.id}
          brandImage={brandSpecial.product_brand.logo_url || ''}
          brandName={brandSpecial.product_brand.name}
          isApplied={false}
          isAuthenticated={isAuthenticated}
          isQualified={false}
          onClick={() =>
            onBrandSpecialClick && onBrandSpecialClick(brandSpecial)
          }
          segmented={brandSpecialOrProductHasSegments({
            brandSpecial: brandSpecial,
          })}
          specialTitle={brandSpecial.title}
          specialType={
            brandSpecial.special_type === 'product' ? 'product' : 'bundle'
          }
          variant="bag"
        />
      )}
    </li>
  );
};
